import { withRouter } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  login,
  logout,
  verifyUserSignup,
  disableUserSignIn,
} from '../../redux/services/login-service/loginService';
import { bindActionCreators } from 'redux';
import AgentLoginForm from '../../components/login/agent-login-form';
import ProgressIndicator from '../../components/common/progress-indicator/progress-indicator';
import moment from 'moment';
export class LoginContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount = () => {
    localStorage.setItem('counter', 0);
  };

  getErrorMessage = () => {
    let errors = this.props.error;
    if (this.props.error === 'User already exists') {
      errors =
        'User already exists. Please login with your credentials or click on Forgot password/User ID';
    } else if (
      this.props.error === 'Incorrect username or password.' &&
      this.state.error !== null
    ) {
      errors = this.state.error;
    } else if (
      this.props.error === 'Incorrect username or password.' &&
      this.state.error === null
    ) {
      errors = 'You have entered an invalid User ID or Password.';
    } else if (
      this.props.error === 'User is disabled.' &&
      this.state.error === null
    ) {
      errors =
        'Your user account has been locked. Please contact 1800-226-3545 to unlock your account.';
    }
    return errors;
  };
  getRemainingAttempst = attempts => {
    console.log(
      'attempts---------------------Number(5 - attempts)',
      Number(5 - attempts),
    );
    return Number(5 - attempts);
  };
  handleSubmit = values => {
    let attempts = parseInt(localStorage.getItem('counter'));
    if (values.email && values.password) {
      this.props.verifyUserSignup(values.email, () => {
        this.props.login(values.email, values.password, () => {
          this.props.history.push('/home');
        });
      });
    }
    console.log('attempts---------------------', attempts);
    localStorage.setItem('counter', parseInt(++attempts));
    let msg = 'You have entered an invalid User ID or Password. ';
    let errorMSg =
      msg +
      `You have  ` +
      this.getRemainingAttempst(parseInt(localStorage.getItem('counter'))) +
      ` attempts remaining before your user account is locked.`;
    if (parseInt(localStorage.getItem('counter')) === 3) {
      this.setState({
        error: errorMSg,
      });
    } else if (parseInt(localStorage.getItem('counter')) === 4) {
      this.setState({
        error:
          msg +
          `You have  ` +
          this.getRemainingAttempst(parseInt(localStorage.getItem('counter'))) +
          ` attempt remaining before your user account is locked.`,
      });
    }
    if (parseInt(localStorage.getItem('counter')) === 5) {
      this.setState({
        error: `For security reasons, your user account has been locked. If you forgot your password, please reset it to unlock your account.`,
      });
      this.props.disableUserSignIn(values.email);
    }
  };

  checkTime = () => {
    let today = moment().format('dddd');
    let estTime = new Date().toLocaleString('en-US', {
      timeZone: 'America/New_York',
    });
    let hrs = moment(estTime).format('HH');

    console.log('the day', today);

    console.log('the time', estTime);
    console.log('the hour', hrs);
    console.log(
      'the hour-1',
      (today !== 'Sunday' && today !== 'Saturday' && (hrs < 5 || hrs >= 21)) ||
        today === 'Sunday' ||
        today === 'Saturday',
    );
    if (
      (today !== 'Sunday' && today !== 'Saturday' && (hrs < 5 || hrs >= 21)) ||
      today === 'Sunday' ||
      today === 'Saturday'
    ) {
      return true;
    }
  };
  render() {
    let message;
    if (this.props.message !== undefined) {
      message = 'You have been successfully registered for the portal.';
    } else if (
      this.props.resetSuccess !== undefined &&
      this.props.resetSuccess
    ) {
      message =
        'Your password has been reset. Please login using the new password.';
    }
    console.log(this.props.error);

    return this.props.isLoading ? (
      <div>
        <ProgressIndicator />
      </div>
    ) : (
      <React.Fragment>
        <AgentLoginForm
          errors={this.getErrorMessage()}
          authErrors={this.props.authenticationError}
          onSubmit={this.handleSubmit.bind(this)}
          successmsg={message}
          showBanner={this.checkTime()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  isLoading: state.appReducer.isLoading,
  error:
    state.registerReducer.error === undefined
      ? state.appReducer.error
      : state.registerReducer.error,
  authenticationError: state.agentApplicationInfoReducer.error,
  message: state.registerReducer.message,
  resetSuccess: state.resetPassReducer.resetSuccess,
});

const mapDispatchToProps = dispatch => ({
  login: bindActionCreators(login, dispatch),
  logout: bindActionCreators(logout, dispatch),
  verifyUserSignup: bindActionCreators(verifyUserSignup, dispatch),
  disableUserSignIn: bindActionCreators(disableUserSignIn, dispatch),
});

LoginContainer.propTypes = {
  error: PropTypes.object,
  message: PropTypes.string,
  login: PropTypes.func,
  history: PropTypes.object,
  isLoading: PropTypes.bool,
  resetSuccess: PropTypes.bool,
  authenticationError: PropTypes.string,
  disableUserSignIn: PropTypes.func,
  verifyUserSignup: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginContainer),
);
